import { Headphones } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { cn } from '@/lib/utils'

export function ReaderAudioBar({ audioUrl, isMobile }: { audioUrl: string; isMobile: boolean }) {
  const { t } = useTranslation()
  return (
    <div className={cn('z-20 border bg-background/95 p-3 backdrop-blur', isMobile ? 'fixed inset-x-0 bottom-0' : 'rounded-md')}>
      <div className="mx-auto flex max-w-[38em] items-center gap-3">
        <Headphones className="size-4 shrink-0 text-primary" />
        <audio className="h-9 min-w-0 flex-1" controls preload="metadata" src={audioUrl}>
          {t('reader.audioUnsupported')}
        </audio>
      </div>
    </div>
  )
}
